import { z } from "zod";
import { makeZodI18nMap } from "zod-i18n-map";

import { useTranslation, zodNS } from "@/lib/i18n";

/**
 * カスタムのZodバリデーションフックを提供します。
 *
 * このフックは、i18nを使用してZodのエラーメッセージを翻訳するためのエラーマップを設定します。
 *
 */
export default function useZodValidation() {
  const { t } = useTranslation();
  z.setErrorMap(makeZodI18nMap({ t, ns: zodNS, handlePath: false }));
}
